import { useLingui } from '@lingui/react/macro';
import { Box, Link, Typography } from '@mui/material';
import { useCallback } from 'react';
import { useDialogStore } from '@/components/dialogs';

export function OneClickTooltipContent() {
  const { t } = useLingui();
  const openDialog = useDialogStore((state) => state.openDialog);

  const handleClick = useCallback(() => {
    openDialog('userPreferencesDrawer');
  }, [openDialog]);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
      <Typography variant="caption">
        {t({
          comment: 'One-click trading required tooltip message',
          message: 'Enable One-Click Trading to allow automated order execution (TP/SL, Stop orders)',
        })}
      </Typography>
      <Link
        component="button"
        type="button"
        variant="caption"
        onClick={handleClick}
        underline="hover"
        sx={{ textAlign: 'left', alignSelf: 'flex-start' }}
      >
        {t({ comment: 'Enable one-click trading in settings link', message: 'Enable in Settings' })}
      </Link>
    </Box>
  );
}
